// hooks/useSetPassword.js
import { useMutation } from "@tanstack/react-query";
import { api } from "../api";
import { API_ROUTES } from "../../routes/apiRoutes";

const setPassword = async ({ password, token }) => {
  const response = await api.post(API_ROUTES.SET_PASSWORD, { password, token });
  return response.data;
};

export const useSetPassword = () => {
  return useMutation({ mutationFn: setPassword });
};
